import {
  StoreSelector,
  useAppStoreSelector,
} from '../../../shared/store/model/context';
import { NotificationSlice } from './types';

type NotificationStoreState = NotificationSlice;
type NotificationStoreSelector<T> = StoreSelector<NotificationStoreState, T>;

export const notificationSelectors = {
  notifications: (state) => state.notifications,
  notify: (state) => state.notify,
  dismissNotification: (state) => state.dismissNotification,
} satisfies Record<string, NotificationStoreSelector<unknown>>;

export function useNotificationStore<T>(
  selector: NotificationStoreSelector<T>
) {
  return useAppStoreSelector(selector);
}
